import * as React from 'react';
import {
  Badge, IconButton, ListItemIcon, Menu, MenuItem, WithStyles, createStyles, withStyles,
} from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import DownloadIcon from '@material-ui/icons/SaveAlt';
import TranslateNew from '@translate/TranslateNew';

const tn = TranslateNew.getInstance();
const styles = createStyles({
  menuPaper: {borderRadius: 8, minWidth: 180},
  menuItem: {fontSize: 14, minHeight: 48},
  menuIcon: {minWidth: 38},
});

interface IProps extends WithStyles<typeof styles> {
  badgeContent: number;
  onSettings: () => void;
  onDownload: () => void;
}

interface IState {
  menuOpen: boolean;
}

export class EconomyMenu extends React.Component<IProps, IState> {
  public state: IState = {menuOpen: false};
  private menuRef = React.createRef<HTMLButtonElement>();

  public render() {
    const {classes, badgeContent, onSettings, onDownload} = this.props;
    const {menuOpen} = this.state;
    return <>
      <IconButton ref={this.menuRef} aria-label={tn.lang.ecoBalanceSettings}
        aria-haspopup="menu" aria-controls={menuOpen ? 'economy-menu' : undefined}
        aria-expanded={menuOpen} onClick={() => this.setState({menuOpen: true})}>
        <Badge badgeContent={badgeContent} showZero={false} variant="dot" color="secondary" overlap="rectangular">
          <SettingsIcon style={{fill: '#6C6C6C'}} />
        </Badge>
      </IconButton>
      <Menu id="economy-menu" anchorEl={this.menuRef.current} open={menuOpen}
        onClose={() => this.setState({menuOpen: false})}
        transformOrigin={{vertical: 'top', horizontal: 'right'}} classes={{paper: classes.menuPaper}}>
        <MenuItem className={classes.menuItem} onClick={() => {
          this.setState({menuOpen: false}); onSettings();
        }}>
          <ListItemIcon className={classes.menuIcon}><SettingsIcon /></ListItemIcon>
          {tn.lang.settings}
        </MenuItem>
        <MenuItem className={classes.menuItem} onClick={() => {
          this.setState({menuOpen: false}); onDownload();
        }}>
          <ListItemIcon className={classes.menuIcon}><DownloadIcon /></ListItemIcon>
          {tn.lang.download}
        </MenuItem>
      </Menu>
    </>;
  }
}

export default withStyles(styles)(EconomyMenu);



// WEBPACK FOOTER //
// ./src/components/economy/EconomyMenu.tsx